export { default } from './BackgroundMedia';
